import { useState, useEffect } from 'react'
import { textWidth } from 'utils/textUtils'
import RichText from 'components/common/richText'
import { MainContainer, MainList } from './faq_styles'

const FAQ = ({ data, leftAlign, width, small, showTitle = true }) => {
  const [maxWidth, setMaxWidth] = useState(0)

  useEffect(() => {
    const questions = data.items.map(item => item.question)
    setMaxWidth((width ? width : textWidth(questions, 'Proxima', 1.6, 400)) + 130)
  }, [data.items, width])

  return (
    <MainContainer leftAlign={leftAlign} id={data.primary.faq_title.replace(/ /g, '-')} small={small}>
      { showTitle &&
        <>
          {small ?
            <h3>{data.primary.faq_title}</h3>
            :
            <h2>{data.primary.faq_title}</h2>
          }
        </>
      }
      <MainList width={maxWidth} small={small}>
        {data.items.map(item =>
          <li key={item.question}>
            <details>
              <summary>{item.question}</summary>
              <RichText data={item.answer} />
            </details>
          </li>
        )}
      </MainList>
    </MainContainer>
  )
}

export default FAQ
